const LandingContent = {
	ingenio: {
		client: "IngenioRx",
		category: "Enterprise applications",
		paras: [
			"Leading the front-end design and build of a major application for IngenioRx, an Anthem startup in the pharmacy benefits market. The app UI enabled the company manage benefits for millions of its commercial and Medicaid customers.",
		],
	},
	igluSearch: {
		client: "Iglu Cruise",
		category: "E-commerce",
		paras: [
			"Customers struggled with the search experience on Iglucruise.com . The UX was not helping them to discover the range of holiday products, deals, and options that were available to them. I created designs that improved this crucial experience and increased bookings both online and via the company's call centre.",
		],
	},
	igluCabins: {
		client: "Iglu Cruise",
		category: "E-commerce",
		paras: [
			"When a customer selects a cruise holiday, they next have to make decisions on a cabin to stay in and its location on the ship. This process is rife with industry jargon and confusing options. I created designs that improved the user experience and increased bookings.",
		],
	},
};

export default LandingContent;
